import {useQuery} from '@tanstack/react-query';

import {useApiClient} from '@/hooks';

import {userAccessApi} from '../api';

import type {ApiResponse, UserAccessDTO} from '@sollapay/types';

export const userAccessKeys = {
  all: ['user-access'] as const
};

// Module-level so React Query can take its identity fast path — an inline `select` re-runs
// on every render of every observer. `usePermissions` builds `useCallback`s off this result,
// so a stable identity here keeps those stable too.
const selectUserAccess = (response: ApiResponse<UserAccessDTO>) => response.data;

export function useUserAccessQuery(options?: {enabled?: boolean}) {
  const client = useApiClient();

  return useQuery({
    queryKey: userAccessKeys.all,
    queryFn: () => userAccessApi.fetchUserAccess(client),
    select: selectUserAccess,
    enabled: options?.enabled
  });
}
